import { useStore, useStoreMap } from 'effector-react'
import { driverModel } from '~/entities/Driver'
import { Button } from '~/shared/ui/Buttons'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { $isLeadWelcomeDrawerShow, hideLeadWelcomeDrawer } from './model'
import {
  Title,
  Description,
  Img,
  Wrapper,
  TitleWrapper,
  ButtonWrapper,
} from './styled'

export function LeadWelcomeDrawer() {
  const driverTaxiparkId = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getMainTaxiparkId(),
  )

  const isLeadWelcomeDrawerShow = useStore($isLeadWelcomeDrawerShow)

  return (
    <DrawerComponent
      isShow={isLeadWelcomeDrawerShow}
      onCancel={hideLeadWelcomeDrawer}
      contentProps={{
        className: 'ion-content-scroll-host',
        style: {
          height: '90vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        },
      }}
    >
      <Wrapper>
        <TitleWrapper>
          <Title data-testid='lead-welcome-drawer-title'>
            Регистрация прошла успешно!
          </Title>
          <Description>
            Вы можете заполнить информацию, необходимую для проверки и доступа к
            бронированию автомобилей, или перейти в каталог для выбора.
          </Description>
        </TitleWrapper>

        <Img src='/images/Success.png' alt='' />

        <ButtonWrapper>
          <Button
            size='large'
            fullWidth
            variant='limeFlooded'
            to={`/registration?taxiparkId=${driverTaxiparkId}`}
            onClick={() => hideLeadWelcomeDrawer()}
            style={{ marginBottom: '12px' }}
          >
            Заполнить данные
          </Button>

          <Button
            size='large'
            fullWidth
            variant='lightSteelBlueBorder'
            to='/booking-cars'
            onClick={() => hideLeadWelcomeDrawer()}
            style={{ marginBottom: '12px' }}
          >
            Вернуться к каталогу
          </Button>
        </ButtonWrapper>
      </Wrapper>
    </DrawerComponent>
  )
}
